import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SegmentedControlsOverflow, SegmentedControlsStyled, } from './segmented-control.styles';
/**
 * This component is a wrapper which can contain several `<SegmentedControl>`s.
 *
 * The props allow for the content to be displayed inline or elevated, and for the container to allow overflowing content to scroll.
 */
export const SegmentedControls = ({ children, isElevated = false, overflowed = false, variant = 'medium', }) => {
    const themeContext = useContext(ThemeContext);
    return overflowed ? (_jsx(SegmentedControlsOverflow, { children: _jsx(SegmentedControlsStyled, { theme: themeContext, isElevated: isElevated, variant: variant, children: children }) })) : (_jsx(SegmentedControlsStyled, { theme: themeContext, isElevated: isElevated, variant: variant, children: children }));
};
//# sourceMappingURL=segmented-controls.js.map